document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("section.clBlocks").forEach((section) => {
    const body = section.querySelector(".body");
    const arrows = section.querySelector(".iconWrapper");
    const [leftBtn, rightBtn] = arrows.querySelectorAll("svg");
    const content = section.querySelector(".content");

    const updateBtns = () => {
      leftBtn.style.opacity = body.scrollLeft <= 0 ? "0" : "1";
      leftBtn.style.pointerEvents = body.scrollLeft <= 0 ? "none" : "auto";

      rightBtn.style.opacity = body.scrollLeft + body.clientWidth >= body.scrollWidth ? "0" : "1";
      rightBtn.style.pointerEvents = body.scrollLeft + body.clientWidth >= body.scrollWidth ? "none" : "auto";
    };

    if (body.scrollWidth > body.clientWidth) {
      arrows.style.display = "flex";
      updateBtns();

      leftBtn.addEventListener("click", () => {
        body.scrollBy({ left: -10, behavior: "smooth" });
      });

      rightBtn.addEventListener("click", () => {
        body.scrollBy({ left: 10, behavior: "smooth" });
      });

      body.addEventListener("scroll", updateBtns);
    } else {
      arrows.style.display = "none";
      if (content) content.style.justifyContent = "center";
    }
  });
});